import { createDictionaryApiFactory, mapDictionaryState } from "./dictionaryApiFactory";

export const mapToImprovementPlanDeleteReason = mapDictionaryState;

const improvementPlanOriginApi = createDictionaryApiFactory("improvementPlanDeleteReasons");

export const getImprovementPlanDeleteReason = improvementPlanOriginApi.search;